import React from 'react';
import Icon from '../AppIcon';

const RoleBadge = ({ role = 'member' }) => {
  const roleConfig = {
    officer: {
      label: 'Officer',
      icon: 'Shield',
      className: 'officer'
    },
    member: {
      label: 'Member',
      icon: 'User',
      className: 'member'
    }
  };

  const config = roleConfig?.[role] || roleConfig?.member;

  return (
    <div className={`role-badge ${config?.className}`}>
      <Icon name={config?.icon} size={14} />
      <span>{config?.label}</span>
    </div>
  );
};

export default RoleBadge;